module.exports = __webpack_public_path__ + "b18f77a5b3c84c01a0c3ae7aef38ffd2.fbx";